/* Joii Employee Benefits Reviews: arrow buttons for the sideways review row, shown only when it overflows. */
(function () {
  function init(section) {
    if (section.dataset.jbReady) return;
    section.dataset.jbReady = '1';
    var track = section.querySelector('.jb-reviews__track');
    var arrows = section.querySelector('.jb-reviews__arrows');
    if (!track || !arrows) return;
    var prev = arrows.querySelector('[data-dir="-1"]');
    var next = arrows.querySelector('[data-dir="1"]');

    function step() {
      var card = track.querySelector('.jb-review');
      var gap = parseFloat(getComputedStyle(track).columnGap) || 24;
      return card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    }
    // arrows only when a card is cut off by the window edge
    function update() {
      var last = track.lastElementChild;
      var lastVisible = !last || last.getBoundingClientRect().right <= window.innerWidth + 1;
      var atStart = track.scrollLeft <= 4;
      arrows.hidden = lastVisible && atStart;
      prev.disabled = atStart;
      next.disabled = lastVisible;
    }
    [prev, next].forEach(function (btn) {
      btn.addEventListener('click', function () {
        track.scrollBy({ left: step() * Number(btn.dataset.dir), behavior: 'smooth' });
      });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAll(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-jb-reviews]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
